import { render } from "./AiReportStatusChip.vue?vue&type=template&id=e3dfa022&ts=true"
import script from "./AiReportStatusChip.vue?vue&type=script&lang=ts"
export * from "./AiReportStatusChip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__